'use client'

import { useCallback } from 'react'
import { useLocale } from 'next-intl'
import { setStoredLocale } from '@/lib/locale-storage'

// The displayed locale must match what the server actually rendered (via NextIntlClientProvider), not an
// independent guess from navigator.language - those two can disagree (e.g. Accept-Language leads the
// server to German while a browser defaulting to en-US leads a language guess to English), which showed
// the wrong flag/highlighted item in the toggle. setStoredLocale still persists an explicit user choice.
export function useLanguageToggle() {
	const locale = useLocale()

	const toggleLocale = useCallback(() => {
		const newLocale = locale === 'en' ? 'de' : 'en'
		setStoredLocale(newLocale)
		window.location.reload()
	}, [locale])

	const changeLocale = useCallback((newLocale: string) => {
		setStoredLocale(newLocale)
		window.location.reload()
	}, [])

	return { locale, toggleLocale, changeLocale, mounted: true }
}
